// hooks/useAuth.js
import { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";

const normalizeRole = (role) => String(role || "").trim().toLowerCase();

export const useAuth = () => {
  const auth = getAuth();
  const db = getFirestore();
  
  const [firebaseUser, setFirebaseUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      setLoading(true);
      setError("");

      if (!user) {
        setFirebaseUser(null);
        setUserProfile(null);
        setCompanyId(null);
        setLoading(false);
        return;
      }

      setFirebaseUser(user);

      try {
        const userSnap = await getDoc(doc(db, "users", user.uid));
        
        if (!userSnap.exists()) {
          setError("User profile not found.");
          setLoading(false);
          return;
        }

        const userData = userSnap.data();
        setUserProfile(userData);

        const compId = userData.companyId;
        if (!compId) {
          setCompanyId(null);
          setError("Your user profile is missing companyId.");
          setLoading(false);
          return;
        }

        setCompanyId(compId);
      } catch (err) {
        console.error("Error loading user profile:", err);
        setError("Failed to load user profile.");
      }

      setLoading(false);
    });

    return () => unsub();
  }, [auth, db]);

  const myRole = normalizeRole(userProfile?.role);
  const isAdmin = myRole === "admin" || myRole === "owner";
  const canDecrementStock = isAdmin || myRole === "enduser";

  return {
    firebaseUser,
    userProfile,
    companyId,
    loading,
    error,
    myRole,
    isAdmin,
    canDecrementStock,
    myId: firebaseUser?.uid || null,
  };
};